import styled from "styled-components";

export const TravelarInformation = styled.div`
  width: 100%;
  color: #1f2937;

  .checkout-summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 11px 12px;
    margin-bottom: 12px;
    border: 1px solid #e5e7eb;
    border-radius: 7px;
    background: #f8fafc;
    font-size: 13px;
  }

  .checkout-summary div,
  .contact-summary div {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .checkout-summary span,
  .contact-summary span {
    color: #64748b;
    font-size: 11px;
  }

  .contact-summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 9px 11px;
    margin-bottom: 14px;
    border: 1px solid #e5e7eb;
    border-radius: 7px;
    font-size: 12px;
  }

  .contact-summary small {
    color: #64748b;
    text-align: right;
  }

  /* Passenger fields: two aligned columns */
  .passenger-fields-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
    gap: 10px 12px;
    width: 100%;
    margin: 10px 0 15px;
  }

  .passenger-fields-grid > div {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    min-width: 0;
  }

  .passenger-fields-grid label {
    display: block;
    min-height: 17px;
    margin: 0 0 4px;
    color: #344054;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.4;
  }

  .passenger-fields-grid input,
  .passenger-fields-grid select {
    display: block;
    width: 100%;
    min-width: 0;
    height: 38px;
    box-sizing: border-box;
    padding: 8px 10px;
    border: 1px solid #d1d5db;
    border-radius: 5px;
    background: #fff;
    font-size: 12px;
    color: #1f2937;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .passenger-fields-grid input:focus,
  .passenger-fields-grid select:focus {
    border-color: #080b3a;
    box-shadow: 0 0 0 2px rgba(8, 11, 58, 0.08);
  }

  .passenger-fields-grid input::placeholder {
    color: #94a3b8;
  }

  .required {
    color: #dc2626;
  }

  .seat-caption {
    margin: -7px 0 9px;
    color: #64748b;
    font-size: 11px;
  }

  .additional-passenger {
    padding: 12px;
    margin: 11px 0;
    border: 1px solid #e5e7eb;
    border-radius: 7px;
    background: #fff;
  }

  /* Continue to payment */
  .checkout-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    margin-top: 18px;
    padding-top: 13px;
    border-top: 1px solid #e5e7eb;
  }

  .checkout-primary-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    min-width: 190px;
    min-height: 40px;
    padding: 9px 19px;
    border: 1px solid #080b3a;
    border-radius: 6px;
    background: #080b3a;
    color: #ffffff;
    font-size: 12px;
    font-weight: 650;
    cursor: pointer;
    transition:
      background 0.2s ease,
      border-color 0.2s ease,
      opacity 0.2s ease,
      transform 0.2s ease,
      box-shadow 0.2s ease;
  }

  .checkout-primary-button:hover:not(:disabled) {
    background: #11164f;
    border-color: #11164f;
    color: #ffffff;
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(8, 11, 58, 0.16);
  }

  .checkout-primary-button:active:not(:disabled) {
    transform: translateY(0);
  }

  .checkout-primary-button:focus-visible {
    outline: 3px solid rgba(8, 11, 58, 0.2);
    outline-offset: 3px;
  }

  .checkout-primary-button:disabled {
    background: #080b3a;
    border-color: #080b3a;
    color: #ffffff;
    cursor: not-allowed;
    opacity: 0.55;
    box-shadow: none;
    transform: none;
  }

  @media (max-width: 560px) {
    /* Keep gender and first name on the same row */
    .passenger-fields-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px 9px;
    }

    .passenger-fields-grid input,
    .passenger-fields-grid select {
      height: 37px;
      padding: 7px 8px;
      font-size: 11px;
    }

    .passenger-fields-grid label {
      font-size: 10px;
    }

    .contact-summary {
      align-items: flex-start;
      flex-direction: column;
    }

    .contact-summary small {
      text-align: left;
    }
  }

  @media (max-width: 350px) {
    .passenger-fields-grid {
      gap: 9px 7px;
    }

    .passenger-fields-grid input,
    .passenger-fields-grid select {
      padding: 6px;
      font-size: 10px;
    }
  }

  @media (max-width: 600px) {
    .checkout-actions {
      justify-content: stretch;
    }

    .checkout-primary-button {
      width: 100%;
      min-width: 0;
    }
  }
`;

export const InformationHeader = styled.h3`
  margin: 13px 0 9px;
  color: #1f2937;
  font-size: 14px;
  font-weight: 700;
`;

export const Country = styled.div`
  width: 100%;
`;

export const FirstNameAndNid = styled.div`
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr);
  gap: 12px;
  width: 100%;
  align-items: stretch;

  select,
  input {
    width: 100%;
    min-width: 0;
    height: 46px;
    box-sizing: border-box;
    margin: 0;
  }

  @media (max-width: 560px) {
    grid-template-columns: 100px minmax(0, 1fr);
    gap: 8px;
  }
`;

export const Nid = styled.div`
  width: 100%;
  min-width: 0;
`;

export const Passenger = styled.div`
  width: 100%;
`;

export const Select = styled.select`
  width: 100%;
  height: 38px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  background: #fff;
  font-size: 12px;
`;

export const UserContactWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;

  > * {
    min-width: 0;
  }
`;